<template>
  <div class="container">
    <h4 v-if="!loggedIn" class="alert alert-success">
      Signed out successfully. Close this tab if you are finished working.
      Click Home to sign in and continue working.
    </h4>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import auth from '../auth';

export default {
  name: 'SignedOut',
  computed: {
    ...mapState({
      user: state => state.User.user,
    }),
    loggedIn() {
      return this.user.name;
    },
  },
  created() {
    auth.clearUser(this.$store);
  },
};
</script>
